import React from 'react';
import PersianDate from 'packages/ui/PersianDate';
import PersianNumber from 'packages/ui/PersianNumber';
import { Table } from '../utils/table.style';

function setTableRowValue(campaignChannel) {
  if (campaignChannel === 'email') {
    return [
      { sent: 'ارسال‌شده' },
      { open: 'باز شده' },
      { click: 'کلیک شده' },
      { unique_open: 'باز شده‌های یکتا' },
      { dropped: 'ارسال نشده' },
      { bounce: 'بانس' },
      { spam: 'اسپم' },
      { invalid: 'نامعتبر' }
    ];
  } else {
    return [
      { delivered: 'دلیور شده' },
      { user_blocked_ads: 'مسدود شده' },
      { undelivered: 'نرسیده' },
      { failed: 'با خطا مواجه شده ' },
      { sent_to_telecommunication_company: 'تحویل مخابرات داده شده' },
      { queued: 'در صف مانده' }
    ];
  }
}

function ServiceProviderStatistics({ data, campaignChannel }) {
  const tableRowValue = setTableRowValue(campaignChannel);

  return (
    <Table>
      <thead>
        <tr>
          <th>آمار سرویس‌دهنده</th>
          {data.map((item, key) => (
            <th key={key}>
              <PersianDate value={item.date} />
            </th>
          ))}
        </tr>
      </thead>

      <tbody>
        {tableRowValue.map(rowItem => {
          let [rowSubject, rowLabel] = Object.entries(rowItem)[0];

          return (
            <tr>
              <th>{rowLabel}</th>
              {data.map((item, key) => (
                <td key={key}>
                  <PersianNumber value={item[rowSubject]} format />
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}

export default ServiceProviderStatistics;
